const utilities = require('utilities');
const model = require('model/model');

module.exports = {
	showDonorboxModalOnce(options) {
		if (model.get('donationModalShown')) {
			return;
		}

		model.set('donationModalShown', true);

		utilities.openModal('#modal-donation-parent', options);
	},
	isRoleThatShowsModal(roleId) {
		roleId = parseInt(roleId);

		return roleId === 384 || roleId === 191963 || roleId === 385 || roleId === 393;
	}
};
